import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from '../../../contexts/AuthContext'
import TablaProveedores from "./TablaProveedores";
import { Button, Row, Table, Col, Input, Label } from "reactstrap";
import Header from "../../../layout/Header/Header";
import axios from "axios";


function ListadoProveedores() {
  const { user } = useContext(AuthContext);
  const URL_PROVEEDORES = process.env.REACT_APP_URL_PROVEEDORES;
  const [proveedores, setProveedores] = useState([]);
  // L80 (2026-06) — buscador
  const [search, setSearch] = useState("");

  useEffect(() => {
   axios
  .get(URL_PROVEEDORES, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allProveedores = response.data.filter(
      (a) => a.tipo === "Proveedor"
    );

    setProveedores(allProveedores);
  })
  .catch((err) => {
    console.log(err);
  });
  },[]);

  return (
    <>     
     <Header />
    <br />
    <br />
    {user.menu_proveedores  ?(
        <div className="card col-12">
          <Row>
              {user.proveedores_create  ?(
              <Button size="sm" type="submit" className="btn btn-success" href="/ProveedoresCreate">Nuevo Proveedor</Button>
              ):(
                <Button size="sm" type="submit" className="btn btn-success" disabled>Nuevo Proveedor</Button>
              )}
              <Button
              size="sm"
              href="/MenuCatalogos"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
            </Row>
                <h3 align="center">Proveedores</h3>
                {/* L80 (2026-06) — buscador */}
                <Row className="mb-2">
                  <Col md={{ size: 4, offset: 8 }}>
                    <Input
                      bsSize="sm"
                      type="text"
                      placeholder="Buscar por nombre, RFC, contacto..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </Col>
                </Row>
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <thead>
                    <tr>
                      <th className="tituloTabla">
                        #
                      </th>
                      <th className="tituloTabla">
                        Nombre Comercial
                      </th>
                      <th className="tituloTabla">
                        Razon Social
                      </th>
                      <th className="tituloTabla">
                        RFC
                      </th>
                      <th className="tituloTabla">
                        Contacto
                      </th>
                      <th className="tituloTabla">
                        Tipo
                      </th>
                      <th className="tituloTabla">
                        Clase
                      </th>
                      <th className="tituloTabla">
                        Telefono
                      </th>
                      <th className="tituloTabla">
                        Email
                      </th>
                      {/* <th className="tituloTabla">
                        Grupo
                      </th> */}
                      <th className="tituloTabla">
                        Editar
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    {proveedores
                      .slice()
                      // L80 (2026-06) — filtra por search
                      .filter((p) => {
                        const q = (search || "").toLowerCase().trim();
                        if (!q) return true;
                        return (
                          (p.nombre_comercial || "").toLowerCase().includes(q) ||
                          (p.razon_social || "").toLowerCase().includes(q) ||
                          (p.RFC || "").toLowerCase().includes(q) ||
                          (p.contacto || "").toLowerCase().includes(q) ||
                          (p.email || "").toLowerCase().includes(q) ||
                          (p.telefono || "").toString().toLowerCase().includes(q) ||
                          String(p.idProveedor || "").includes(q)
                        );
                      })
                      .sort(
                        (a, b) =>
                          (Number(a.idProveedor) || 999999) -
                          (Number(b.idProveedor) || 999999)
                      )
                      .map((p) => {
                      return (
                        // key estable por proveedor: evita que React reuse la fila
                        // por posición y muestre datos de otro proveedor al editar
                        <tr key={p._id}>
                          <TablaProveedores
                            numero={p.idProveedor}
                            nomcom={p.nombre_comercial}
                            razsoc={p.razon_social}
                            RFC={p.RFC}
                            contacto={p.contacto}
                            telefono={p.telefono}
                            email={p.email}
                            _id={p._id} is_active={p.is_active}
                            calle={p.calle}
                            numero_ext={p.numero_ext}
                            numero_int={p.numero_int}
                            delegacion={p.delegacion}
                            estado={p.estado}
                            pais={p.pais}
                            cp={p.cp}
                            colonia={p.colonia}
                            ciudad={p.ciudad}
                            tipo={p.tipo}
                            telaHab={p.telaHab}
                            idProveedor={p._id}
                            plazo={p.plazo}
                          />
                        </tr>
                      )
                    })}
                  </tbody>
                </Table>
        </div>
      ): undefined } 
    </>
  );
}

export default ListadoProveedores;
